import { Component } from '@angular/core';

@Component({
    selector: 'main-activity-log',
    template: require('./main-activity-log.html'),
    styles: [require('./main-activity-log.scss')]
})
export default class MainActivityLog {
    private isActivityLogVisible: boolean = false;
    constructor() {
    }

    ngOnInit() {
        this.isActivityLogVisible = true;
    }

    goBack() {
        this.isActivityLogVisible = false;
        window.history.back();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/activity-log/main-activity-log.component.ts